export enum Types {
  INCREMENT_REQUESTS_COUNT = 'INCREMENT_REQUESTS_COUNT',
  DECREMENT_REQUESTS_COUNT = 'DECREMENT_REQUESTS_COUNT',
}

export const incrementRequestCount = () => ({ type: Types.INCREMENT_REQUESTS_COUNT })
export const decrementRequestCount = () => ({ type: Types.DECREMENT_REQUESTS_COUNT })
